module.exports = __webpack_public_path__ + "static/media/ff3f88617e38897171ae3dd468b077e4_html_66db3253ab2f58e3.91e6d917.png";